module.exports = __webpack_public_path__ + "static/media/destination-pl.69f0f517.svg";